const messages = {
    dashboard: {
        title: "Grossist-dashboard",
        extraTitle: "GROSSIST-DASHBOARD",
        description:
            "Velkommen til dit dashboard. Her kan du se tallene og de deltagende virksomheder fra din kundebase.",
        overview: {
            title: "Oversigt over deltagende kunder",
            description:
                "Virksomheder, der har tilmeldt sig BRIDGESTONE PLUS, og som vi kan tildele til dit firma via deres kundenummer.",
            month: "Ny denne måned",
            year: "Ny i år",
            all: "I alt",
        },
        credits: {
            title: "Pointkreditter {name}",
            description:
                "Belønningspoint tildelt deltagende virksomheder baseret på de salgstal, du har uploadet. I denne visning vises de almindelige point uden kampagner.",
            month: "Sidste måned",
            year: "Nuværende år",
            prev_year: "I alt",
            allDealers: "Alle forhandleres point",
        },
        details: {
            title: "Detaljer om deltagende kunder",
            description:
                'Nedenfor finder du virksomheder, der har registreret sig hos BRIDGESTONE <span class="text-danger">PLUS</span> med et {name} kundenummer og som er tildelt dig som ansvarlig. Brug sorteringsfunktionerne for at ændre rækkefølgen eller søgefeltet for at finde kunder.',
        },
        lastImport:
            'Sidste import af salgstal: <br/> <span class="text-danger">{date}</span>',
        loadMore: "Indlæs 20 flere forhandlere",
        tyres: {
            title: "Dæk",
            description: "Dæk købt af deltagere i programmet",
        },
    },
};

export default {
    messages,
};
